class DropdownComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        :host {
          position: relative;
          display: inline-block;
        }
        .dropdown-content {
          display: none;
          position: absolute;
          background-color: white;
          min-width: 160px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
          line-height: 40px;
          padding: 28px;
          z-index: 10;
          top: calc(100% + 20px);
        }

        :host([open]) .dropdown-content {
          display: block;
        }

        @media (max-width: 768px) {
          .dropdown-content {
            padding: 14px;
            top: calc(100% + 10px);
          }
        }
      </style>
      <slot name="button"></slot>
      <div class="dropdown-content" id="dropdown-panel">
        <slot name="content"></slot>
      </div>
    `;

    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this._button = this.querySelector('[slot="button"]');
    this._panel = this.shadowRoot.querySelector('#dropdown-panel');
    this._slotContent = this.shadowRoot.querySelector('slot[name="content"]');
  }

  connectedCallback() {
    if (this._button) {
      this._button.setAttribute('aria-haspopup', 'true');
      this._button.setAttribute('aria-expanded', 'false');
      this._button.setAttribute('aria-controls', 'dropdown-panel');
      this._button.addEventListener('click', this.toggle.bind(this));
    }

    this.addEventListener('keydown', this._handleKeydown.bind(this));
    document.addEventListener('click', this._handleDocumentClick.bind(this));
  }

  disconnectedCallback() {
    if (this._button) {
      this._button.removeEventListener('click', this.toggle.bind(this));
    }
    this.removeEventListener('keydown', this._handleKeydown.bind(this));
    document.removeEventListener('click', this._handleDocumentClick.bind(this));
  }

  toggle(event) {
    event.stopPropagation();
    this.isOpen() ? this.close() : this.open();
  }

  isOpen() {
    return this.hasAttribute('open');
  }



  open() {
    this.setAttribute('open', '');
    if (this._button) {
      this._button.setAttribute('aria-expanded', 'true');
    }
  }

  close() {
    this.removeAttribute('open');
    if (this._button) {
      this._button.setAttribute('aria-expanded', 'false');
    }
    this._button.focus();
  }

  _handleKeydown(event) {
    if (!this.isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }
  }

  _handleDocumentClick(event) {
    if (this.isOpen() && !this.contains(event.target)) {
      this.close();
    }
  }
}

customElements.define('dropdown-component', DropdownComponent);